"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseEventbriteEventId = parseEventbriteEventId;
/**
 * Event ID from an Eventbrite link or a bare ID. Links look like
 * `https://www.eventbrite.com/e/name-tickets-123456789012?aff=…` (any eventbrite.* domain),
 * `…/e/123456789012`, or carry `?eid=123456789012`.
 */
function parseEventbriteEventId(input) {
  const value = (input || '').trim();
  if (/^\d{6,}$/.test(value)) return value;
  let url;
  try {
    url = new URL(/^https?:\/\//i.test(value) ? value : "https://".concat(value));
  } catch (_unused) {
    return null;
  }
  const host = url.hostname.toLowerCase();
  if (!/(^|\.)eventbrite\.[a-z.]+$/.test(host) && !/(^|\.)eventbriteapi\.com$/.test(host)) return null;
  const eid = url.searchParams.get('eid');
  if (eid && /^\d{6,}$/.test(eid)) return eid;
  // Only event pages: /e/<slug>-<id> or /e/<id> (site), /v3/events/<id>/ (API).
  const match = url.pathname.match(/\/(?:e|events)\/(?:[^/]*-)?(\d{6,})\/?$/);
  return match ? match[1] : null;
}
//# sourceMappingURL=eventbrite-event-id.js.map